import React from 'react';
import PackagesPage from 'components/PackagesPage';

const OtherPage = () => {
  return (
    <div>
      <PackagesPage
        category={'other'}
        messageID={'pages.products.otherPage'}
        descriptionID={'pages.products.otherPage.description'}
      />
    </div>
  );
};

export default OtherPage;
